<a (click)="goToHome()" aria-current="page">
  <img [src]="getImagePath('TINYVIEW_MARK_AND_LOGO')" class="tv-logo" alt="tv-logo">
</a>
